export default [
  { value: 'direct', label: 'Sonido directo' },
  { value: 'postproduction', label: 'Sonido de Post Producción' },
];



// WEBPACK FOOTER //
// ./src/utils/selectors/SoundTypeOptions.js